import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "form_button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_nav_bar, {
    title: "个人信息",
    "left-arrow": "",
    onClickLeft: $setup.goBack,
    fixed: "",
    placeholder: ""
  }, null, 8, ["onClickLeft"]), _createVNode(_component_van_cell_group, null, {
    default: _withCtx(() => [_createVNode(_component_van_field, {
      modelValue: $setup.formData.user_phone,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.formData.user_phone = $event),
      label: "登录账号",
      readonly: ""
    }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
      modelValue: $setup.formData.shop_name,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.formData.shop_name = $event),
      label: "店铺名称",
      placeholder: "请输入店铺名称",
      required: ""
    }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
      modelValue: $setup.formData.shop_add,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.formData.shop_add = $event),
      label: "店铺地址",
      placeholder: "请输入店铺地址"
    }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
      modelValue: $setup.formData.true_name,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.formData.true_name = $event),
      label: "联系人",
      placeholder: "请输入联系人",
      required: ""
    }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
      modelValue: $setup.formData.user_wechar,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.formData.user_wechar = $event),
      label: "微信号",
      placeholder: "请输入微信号",
      required: ""
    }, null, 8, ["modelValue"])]),
    _: 1
  }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_button, {
    type: "primary",
    round: "",
    block: "",
    onClick: $setup.saveInfo
  }, {
    default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("提交")])),
    _: 1
  }, 8, ["onClick"])])], 64);
}